import { Application } from "@hotwired/stimulus"
import ThemeController from "./theme_controller"

window.Stimulus = Application.start()
Stimulus.register("theme", ThemeController)
